import { render, staticRenderFns } from "./BankInstructionIndex.vue?vue&type=template&id=002d241b&scoped=true&"
import script from "./BankInstructionIndex.vue?vue&type=script&lang=js&"
export * from "./BankInstructionIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002d241b",
  null
  
)

export default component.exports